import{jsx as r}from"react/jsx-runtime";import t from"html-react-parser";import{useSeoBlockContext as e}from"./hooks/index.js";const n=()=>{const{text:o}=e();return o?r("div",{children:t(o)}):null};export{n as SeoBlockText};
